import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useMsal } from "@azure/msal-react";
import dayjs from "dayjs";
import { UserManagentContext } from "../customHooks/dataProviders/UserManagementProvider";

const ProtectedRoute = ({ children, roleName = [] }) => {
  const { accounts, inProgress } = useMsal();
  const { isLoggingOut } = React.useContext(UserManagentContext);
  const isAuthenticated = localStorage.getItem("jwtToken");
  const expiryTime = localStorage.getItem("expiryTime");

  // If MSAL is currently handling a redirect or checking for a session,
  // or if a manual logout is in progress, do not navigate away yet.
  if (inProgress !== "none" || isLoggingOut) {
    return <div>Loading...</div>; // Or a more stylized loader
  }

  // Check if token or expiry is missing or expired
  if (!isAuthenticated || !expiryTime || dayjs().isAfter(dayjs(expiryTime))) {
    console.log("ProtectedRoute: Not authenticated. MSAL Status:", inProgress, "Accounts:", accounts.length);

    // If a Microsoft account is already present, wait for SSOHandler to sync it
    if (accounts.length > 0) {
      console.log("ProtectedRoute: Microsoft account detected. Waiting for SSO sync to /home...");
      return (
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <div>Signing in with Microsoft...</div>
        </div>
      );
    }

    console.log("Token missing or expired. Redirecting to login.");
    localStorage.removeItem("jwtToken");
    localStorage.removeItem("expiryTime");
    localStorage.removeItem("roleNames");
    return <Navigate to="/login" />;
  }
  // Role check
  if (roleName.length > 0) {
    const roleNames = JSON.parse(localStorage.getItem("roleNames") || "[]");
    console.log("Stored roles:", roleNames);
    console.log("Required roles:", roleName);

    // Check if any of the required roles match the user's roles
    const hasRequiredRole = roleName.some((role) => roleNames.includes(role));

    if (!hasRequiredRole) {
      console.log("User lacks the required role. Redirecting to home.");
      return <Navigate to="/home" />;
    }
  }

  return children || <Outlet />;
};

export default ProtectedRoute;
